export var FREQUENTLY_BOUGHT_TOGETHER_ID = 'UmVjb21tZW5kYXRpb25BSU5vZGU6NQ==';
export var OTHERS_YOU_MAY_LIKE_ID = 'UmVjb21tZW5kYXRpb25BSU5vZGU6Ng==';